import React from 'react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Take a 5-minute assessment.',
    description: 'Tell us about your symptoms, medical history, and goals.'
  }, {
    number: '2',
    title: 'Meet your physician online.',
    description: 'A board-certified Orla doctor reviews your case and builds a custom plan.'
  }, {
    number: '3',
    title: 'Treatment to your door.',
    description: 'Free shipping, unlimited follow-ups, pause or cancel anytime.'
  }];
  return <section className="bg-orla-bone py-16 md:py-32" data-id="element-208">
      <div className="max-w-[1240px] mx-auto px-6" data-id="element-209">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20" data-id="element-210">
          {/* Left Column */}
          <div className="md:col-span-6 flex flex-col justify-center" data-id="element-211">
            <p className="font-body font-semibold text-[13px] text-orla-saffron uppercase tracking-[0.06em]" data-id="element-212">
              HOW IT WORKS
            </p>
            <h2 className="mt-4 font-display font-black text-[32px] md:text-[48px] text-orla-ink tracking-tight leading-[1.1]" data-id="element-213">
              Care in three simple steps.
            </h2>

            <div className="mt-12 space-y-8" data-id="element-214">
              {steps.map((step, idx) => <div key={idx} className="flex gap-6" data-id="element-215">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-orla-sienna flex items-center justify-center" data-id="element-216">
                    <span className="font-display font-black text-[20px] text-orla-bone" data-id="element-217">
                      {step.number}
                    </span>
                  </div>
                  <div className="flex-1 max-w-[400px]" data-id="element-218">
                    <h3 className="font-display font-semibold text-[20px] text-orla-ink leading-[1.3]" data-id="element-219">
                      {step.title}
                    </h3>
                    <p className="mt-2 font-body text-[15px] text-orla-muted leading-[1.5]" data-id="element-220">
                      {step.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <button className="mt-12 self-start px-8 py-3.5 bg-orla-sienna text-orla-bone font-body font-semibold text-[15px] rounded-full hover:brightness-90 hover:shadow-lg transition-all" data-id="element-221">
              Start My Care
            </button>
          </div>

          {/* Right Column */}
          <div className="md:col-span-6 order-first md:order-last" data-id="element-222">
            <div className="rounded-2xl overflow-hidden shadow-lg" style={{
            aspectRatio: '4/5'
          }} data-id="element-223">
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80" alt="Woman relaxed at home" className="w-full h-full object-cover" data-id="element-224" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}